import type { FC, ReactNode } from 'react';
import { View } from 'react-native';
import type { ViewProps } from 'react-native';

import { useAppTheme } from '@/styles/hooks/useAppTheme';

type Props = {
  children: ReactNode;
  /**
   * Background color painted above the wrapped `NavigationBar` to cover the
   * status bar / notch area. Defaults to `theme.colors.surfaceContainer` so
   * content underneath (e.g. a `GradientBackground`) does not bleed through.
   */
  backgroundColor?: string;
} & Pick<ViewProps, 'testID'>;

/**
 * Wraps a `NavigationBar` with a colored background that extends upward to
 * cover the status bar / notch area. Useful for screens whose body renders a
 * non-surface gradient or image, where the default transparent Appbar would
 * otherwise show that gradient through the status bar.
 */
export const StatusBarBackground: FC<Props> = ({
  children,
  backgroundColor,
  testID
}) => {
  const theme = useAppTheme();

  return (
    <View
      testID={testID}
      style={{
        backgroundColor: backgroundColor ?? theme.colors.surfaceContainer
      }}
    >
      {children}
    </View>
  );
};
